import { render, staticRenderFns } from "./ConsultantMaterials.vue?vue&type=template&id=d802416e"
import script from "./ConsultantMaterials.vue?vue&type=script&lang=js"
export * from "./ConsultantMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports